module.exports = __webpack_public_path__ + "labioplastika_8_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/labioplastika_8_before_tn.jpg
// module id = 1550
// module chunks = 0